import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './home.scss';
import { serviceCall } from "../../Utils/ServiceUtils";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Home = () => {
    const [productsLst, setProductsLst] = useState([]);
    let responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1024 },
            items: 5,
            slidesToSlide: 2,
        },
        desktop: {
            breakpoint: { max: 1024, min: 800 },
            items: 4,
        },
        tablet: {
            breakpoint: { max: 800, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
        },
    };

    useEffect(() => {
        productsListHandler();
    }, [])

    const productsListHandler = async () => {
        const resp = await serviceCall("GET", "/API/Product/GetProducts");
        if (resp && !(resp.IsError === true)) {
            setProductsLst(resp);
        }
    }

    return (
        <>
            <div className="scrnPading">
                <h1 className="dayDeals">Deals of the Day</h1>
                <Carousel responsive={responsive}>
                    {productsLst.length > 0 &&
                        productsLst.map((element, i) => {
                            return (<div key={i} className="card" >
                                <Link to={`/product/${element.Id}`} style={{ textDecoration: "none", color: 'rgb(33,37,41)' }}>
                                    <img className="product--image" src={element.ImageUrl} alt={element.ImageUrl} />
                                    <h5 className="textCapital mt-2 mx-3">{element.Name}</h5>
                                    <span className="priceD">&#8377;{element.Price}</span>
                                    <span className="strikePrice">&#8377;{element.Price*2}</span>
                                </Link>
                            </div>)
                        })}
                </Carousel>
            </div>
        </>
    );
};

export default Home;